














































































































































import { createComponent, onMounted, ref, watch, reactive } from '@vue/composition-api'
// import { project } from '@/assets/project'
import { currentCode, isEditNew, setCodeState, setStateNew } from '@/assets/code-edit'
import { currentPage, Page } from '@/assets/page'
import { getDocHeight, parseCodeValid, updateByField } from '@/assets/util'
// import { MessageBox } from 'element-ui'
import { fxList, varList } from '@/assets/event'
import { NodeItem } from '@/assets/node'
import { initGlobalConfig } from '@/components/mobile-render/render/utils'
import LeftBlock from './left-block.vue'
import { blockList } from './config'

type Editor = {
  getPosition: any,
  executeEdits: any,
  setPosition: any,
  focus: any
}
type BlockItem = {
  label: string
  field: string
  getData: () => any
}
type ResItem = { label: string, value: string, children: ResItem[] }

export default createComponent({
  components: {
    LeftBlock
  },

  setup () {
    const areaHeight = ref(0)
    const code = ref('')
    const canMount = ref(false)
    const canMountAfterLoading = ref(false)
    const editor = ref<Editor>(null)
    const editBlockList = reactive<Array<BlockItem>>(blockList)
    const codeRenderNotice = ref<{ state: ResItem[], methods: ResItem[], nodes: any[] }>({
      state: [],
      methods: [],
      nodes: []
    })
    const codeChangeTimer = ref(-1)

    const handleCancel = () => {
      setStateNew(false)
    }
    const handleClickFx = (item: any) => {
      if (editor.value) {
        const position = editor.value.getPosition()
        editor.value.executeEdits('', [
          {
            range: {
              startLineNumber: position.lineNumber,
              startColumn: position.column,
              endLineNumber: position.lineNumber,
              endColumn: position.column
            },
            text: item.code
          }
        ])
        position.column += item.code.length
        editor.value.setPosition(position)
        editor.value.focus()
      }
    }
    const isObj = (obj: any) => obj && typeof obj === 'object' && !Array.isArray(obj)
    const _df = (obj: any, path: string[], res: Array<ResItem>): any => {
      if (isObj(obj)) {
        Object.keys(obj).forEach((k: string) => {
          const item = { label: k, value: `${path.join('.')}.${k}`, children: [] }
          res.push(item)
          if (isObj(obj[k])) {
            path.push(k)
            _df(obj[k], path, item.children)
            path.pop()
          }
        })
      }
    }
    const _dfBy = (arr: any[], newArr: any = [], assert: any, cb?: any) => {
      const deepAdd = !cb
      if (deepAdd) {
        for (let i = 0; i < arr.length; i++) {
          if (assert(arr[i])) {
            newArr.push(arr[i])
          }
          if (arr[i].children) {
            _dfBy(arr[i].children, newArr, assert, cb)
          }
        }
        return false
      }
      let flag = false
      for (let i = 0; i < arr.length; i++) {
        const tmp = cb(arr[i])
        let childrenFlag = false
        if (arr[i].children) {
          childrenFlag = _dfBy(arr[i].children, tmp.children, assert, cb)
        }
        if (assert(arr[i])) {
          flag = true
          newArr.push(tmp)
        } else if (childrenFlag) {
          flag = true
          newArr.push(tmp)
        }
      }
      return flag
    }
    const handleCollectionBlock = (page: Page | null = currentPage.value) => {
      if (page) {
        // 重置
        codeRenderNotice.value = {
          state: [],
          methods: [],
          nodes: []
        }
        const { state, methods, events, nodes } = page as Page
        const ctx = { $$page: { state: {}, methods: {} }, $$global: initGlobalConfig(page as Page) }
        // 解析视图
        const stateRes = parseCodeValid(state, ctx)
        if (stateRes.ok) {
          const result: Array<ResItem> = []
          _df(stateRes.value, [], result)
          codeRenderNotice.value.state = result
        }
        // 解析方法
        const methodsRes = parseCodeValid(methods, ctx)
        if (methodsRes.ok) {
          const result: Array<ResItem> = []
          _df(methodsRes.value, [], result)
          codeRenderNotice.value.methods = result
        }
        // 解析节点事件和自定义render
        codeRenderNotice.value.nodes.push({
          id: page.id,
          title: page.title,
          events: events.map((item) => {
            return {
              id: page.id,
              title: `${page.title} ${item.desc || item.eventType}`,
              fxCode: item.fxCode,
              self: item,
              field: 'fxCode',
              isBlockEvent: true
            }
          })
        })
        const asserts = (node: NodeItem) => {
          return node.events.length || node.nodeType === 4
        }
        const dealItem = (node: NodeItem) => {
          const isBlockEvent = !!node.events.length
          const isSpa = node.nodeType === 4
          const res = {
            id: node.id,
            title: node.title,
            events: [],
            renderString: '',
            field: 'renderString',
            language: node.subType === 'spa' ? 'html' : undefined,
            children: [],
            self: isSpa ? node : null,
            isSpa
          }
          if (isBlockEvent) {
            res.events = node.events.map((x :any) => ({
              id: node.id,
              title: `${node.title} ${x.desc || x.eventType}`,
              fxCode: x.fxCode,
              self: x,
              field: 'fxCode',
              isBlockEvent
            }))
          }
          if (isSpa) {
            res.renderString = node.renderString
          }
          return res
        }
        _dfBy(nodes, codeRenderNotice.value.nodes, asserts, dealItem)
      }
    }
    const handleOpenCodeBlock = (item: any) => {
      if (item.isSpa !== undefined || item.isBlockEvent !== undefined) {
        // 节点编辑
        if (item.isSpa || item.isBlockEvent) {
          const update = (val: string) => {
            // 更新节点树自己
            if (item.isSpa) {
              item.renderString = val
            } else {
              item.fxCode = val
            }
            // 更新源代码
            updateByField(item.self, item.field, val)
          }
          setCodeState(
            item.title,
            item.isSpa ? item.renderString : item.fxCode,
            update,
            item.language,
            { isNew: true, itemId: item.id, eventIndex: item.isBlockEvent ? 0 : undefined }
          )
        }
      } else if (item.getData) {
        const data = item.getData()
        setCodeState(
          item.label,
          data[item.field],
          (val: string) => {
            updateByField(data, item.field, val)
          },
          item.language,
          { isNew: true, itemId: data.id }
        )
      }
    }

    watch(() => currentCode.code, (val: string) => {
      code.value = val
    })
    // 必须等到动画过完才能渲染编辑器
    watch(() => isEditNew.value, val => {
      if (val) {
        if (currentCode.attaches && currentCode.attaches.setInSchema) {
          const { itemId, eventIndex } = currentCode.attaches
          // 递归找到这个节点或事件
          const res: any = []
          _dfBy(
            codeRenderNotice.value.nodes,
            res,
            (item: any) => {
              return item.id === itemId && (eventIndex !== undefined && item.events && item.events.length)
            }
            // (item: any) => JSON.parse(JSON.stringify(item))
          )
          // console.log(res)
          // console.log(eventIndex)
          if (res.length) {
            if (eventIndex !== undefined) {
              handleOpenCodeBlock(res[0].events[eventIndex])
            } else {
              handleOpenCodeBlock(res[0])
            }
          }
        }
        canMountAfterLoading.value = true
        // hide popover
        document.body.click()
        setTimeout(() => {
          canMount.value = true
        }, 500)
      } else {
        canMount.value = false
      }
    })
    watch(
      () => currentPage.value,
      (page) => {
        handleCollectionBlock(page)
        if (isEditNew.value) {
          // 编辑器状态
          // 切换页面时，切换编辑器内容
          if (codeRenderNotice.value.nodes[0]) {
            handleOpenCodeBlock(codeRenderNotice.value.nodes[0])
          } else {
            handleOpenCodeBlock(editBlockList[0])
          }
        }
      },
      { lazy: true }
    )

    onMounted(() => {
      areaHeight.value = getDocHeight()
    })

    return {
      areaHeight,
      code,
      canMount,
      canMountAfterLoading,
      isEditNew,
      currentCode,
      amdRequire: window.require,
      // hasLeftPanel: computed(() => currentCode.title !== '系统配置'),
      codeRenderNotice,
      codeChangeTimer,
      fxList,
      varList,
      editBlockList,
      handleClickFx,
      handleNodeClick (data: any) {
        handleClickFx({ code: `$$page.state${data.value[0] === '.' ? '' : '.'}${data.value}` })
      },
      handleCancel,
      // handleConfirm,
      handleOpenCodeBlock,
      handleCollectionBlock,
      handleCodeChange (val: string) {
        code.value = val
        if (codeChangeTimer.value) {
          clearTimeout(codeChangeTimer.value)
          codeChangeTimer.value = 0
        }
        // 自动保存
        codeChangeTimer.value = setTimeout(() => {
          // console.log(`auto save ${currentCode.title}`)
          currentCode.update(val)
          codeChangeTimer.value = 0
        }, 1000)
      },
      handleMounted (editorInstance: any) {
        editor.value = editorInstance
        canMountAfterLoading.value = false
        editorInstance.addCommand(window.monaco.KeyMod.CtrlCmd | window.monaco.KeyCode.KEY_S, function () {
          currentCode.update(code.value)
          codeChangeTimer.value = 1
          setTimeout(() => {
            codeChangeTimer.value = 0
          }, 100)
          // window.globalApp.$notify({
          //   title: '成功',
          //   message: `保存 ${currentCode.title}`,
          //   type: 'success',
          //   duration: 2000,
          //   position: 'top-left'
          // })
        })
        editorInstance.addCommand(window.monaco.KeyMod.CtrlCmd | window.monaco.KeyCode.KEY_D, function () {
          handleCancel()
        })
      }
    }
  }
})
